var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCryptex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "810pt",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 805 810",
    width: "805pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.1 0 0 -.1 0 810)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3745 7914c-298-31-515-69-738-130-1480-407-2589-1645-2822-3151-78-506-57-1034 61-1523 326-1356 1337-2426 2674-2829 392-119 779-168 1220-158 270 7 452 27 695 77 1067 222 1993 881 2557 1820 278 462 452 973 525 1535 25 199 25 711 0 910-25 191-60 377-101 536-357 1377-1442 2458-2812 2803-152 38-311 68-486 92-108 15-675 28-773 18zm730-298c587-78 1078-259 1550-570 372-246 737-602 987-966 470-682 698-1514 638-2325-35-465-146-881-346-1295-213-440-485-803-839-1123-980-883-2354-1167-3597-741-1638 561-2653 2218-2412 3939 74 531 262 1024 565 1480 135 202 249 343 414 514 620 639 1425 1021 2317 1100 143 13 589 5 723-13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2590 4340v-1460h1440 1440v375 375h-710-710l2 723 3 722 708 3 707 2v360 360h-1440-1440z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2590 2080v-70h1445 1446l-3 68-3 67-1442 3-1443 2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryptex);
export default __webpack_public_path__ + "static/media/cryptex.4e33650f65a3b7e045acc01e82a7caab.svg";
export { ForwardRef as ReactComponent };